import { Modal, Stack } from "@mantine/core"
import { Button, IconMultipleNavion, IconNavion } from "@tfg/ui"
import { useState } from "react"
import { useTranslation } from "react-i18next"

import { ContactSelect } from "~/pages/SupplierPortal/TraceabilityRequests/components/ContactSelect.tsx"
import { useTransferProdsiteFieldRequestValuesMutation } from "~/pages/SupplierPortal/TraceabilityRequests/hooks.ts"
import { useAuth } from "~/store/auth-context"
import { showSuccessNotification } from "~/utils/showSuccessNotification"

interface Props {
  opened: boolean
  onClose: () => void
  prodSiteFieldValueIds: number[]
}

export const TransferProdSiteRequestModal = ({
  opened,
  onClose,
  prodSiteFieldValueIds,
}: Props) => {
  const { t } = useTranslation("traceability")
  const { user, isAdmin } = useAuth()

  const { mutate: transferProdSiteRequest, isPending: isLoading } =
    useTransferProdsiteFieldRequestValuesMutation({
      onSuccess: ({ count }) => {
        showSuccessNotification({
          message: t("prodsiterequest.transferModal.success", { count }),
          title: t("prodsiterequest.transferModal.success", { count }),
        })
        onClose()
      },
    })

  const [contactId, setContactId] = useState<string>("")
  if (!user?.id) {
    return null
  }
  return (
    <Modal
      title={t("prodsiterequest.transferModal.title")}
      opened={opened}
      onClose={onClose}
    >
      <Stack>
        <ContactSelect
          contactId={contactId}
          onContactSelected={setContactId}
          userId={user?.id}
          isAdmin={isAdmin}
        />

        <Button
          disabled={!contactId}
          onClick={() =>
            contactId &&
            transferProdSiteRequest({
              contactId,
              prodSiteFieldValues: prodSiteFieldValueIds,
            })
          }
          loading={isLoading}
          variant="primary"
          rightSection={
            prodSiteFieldValueIds.length === 1 ? (
              <IconNavion hovered={false} fill="var(--mantine-color-white)" />
            ) : (
              <IconMultipleNavion
                hovered={false}
                fill="var(--mantine-color-white)"
              />
            )
          }
        >
          {t("prodsiterequest.transferModal.transferButton")}
        </Button>
      </Stack>
    </Modal>
  )
}
